// @ts-nocheck
import { getFormById, getForms } from "@store/Framework/Store/Starter/Components/Form/FormSelectors";
import { BaseFormHandlerParameter, FormModel } from "@store/Framework/Store/Starter/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";

export interface SetHasAlreadyErrorsHandlerParameter extends BaseFormHandlerParameter {}

export interface SetHasAlreadyErrorsHandlerProps {
    forms: FormModel[];
}

type HandlerType = Handler<SetHasAlreadyErrorsHandlerParameter, SetHasAlreadyErrorsHandlerProps>;

export const PopulateForm: HandlerType = props => {
    const state = props.getState();
    const form = getFormById(state, props.parameter.formId);
    let forms = getForms(state);

    if (form) {
        forms = [...forms];
        const _form = cloneDeep(form);
        _form.hasAlreadyError = form.inputs.some(x => x.error !== "");

        if (_form.hasAlreadyError === form.hasAlreadyError) {
            return;
        }

        const formIndex = findIndex(forms, x => x.id === _form.id);
        forms.splice(formIndex, 1, _form);
    }

    props.forms = forms;
};

export const DispatchSetInput: HandlerType = props => {
    props.dispatch({
        type: "Starter/Components/Form/SetInput",
        forms: props.forms,
    });
};

export const chain = [PopulateForm, DispatchSetInput];

const setHasAlreadyErrors = createHandlerChainRunner(chain, "SetHasAlreadyErrors");

export default setHasAlreadyErrors;
